export const SKILL_MD_PATH = 'SKILL.md';

export const BINARY_FILE_PREVIEW_MESSAGE = 'Binary file — contents not shown.';

/**
 * File extensions whose contents can be rendered as text in skill file previews.
 *
 * Skill supporting files may be binary (slide decks, images, PDFs), and rendering those as text
 * can make the browser unresponsive. Paths with unknown or missing extensions therefore fail
 * closed and are not inlined.
 *
 * TODO: Decide this from media type or other server-provided metadata when that is reliably
 * available to every skill preview caller.
 */
const TEXT_FILE_EXTENSIONS: ReadonlySet<string> = new Set([
  'cfg',
  'csv',
  'html',
  'ini',
  'js',
  'json',
  'jsx',
  'log',
  'md',
  'py',
  'r',
  'sh',
  'sql',
  'toml',
  'ts',
  'tsv',
  'tsx',
  'txt',
  'xml',
  'yaml',
  'yml',
]);

/**
 * Whether a skill file's content can be safely shown as text based on its path.
 */
export function isTextPreviewablePath(path: string): boolean {
  const lastDotIndex = path.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return false;
  }
  return TEXT_FILE_EXTENSIONS.has(path.slice(lastDotIndex + 1).toLowerCase());
}
